import React from 'react';
import PropTypes from 'prop-types';

export default function Policy({ onChange }) {
  return (
    <div className={'flex gap-4'}>
      <input onChange={onChange} type="checkbox" id={'policy'} />
      <label className="text-xs max-w-[350px]" htmlFor={'policy'}>
        J’accepte d’être contacté par Hellio ou mon point de vente Bricomarché
        dans lequel je réalise la simulation pour l’exécution du service
        souscrit.
      </label>
    </div>
  );
}

Policy.propTypes = {
  onChange: PropTypes.func.isRequired,
};
